var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-page"},[_c('div',{staticClass:"loading-content"},[_c('img',{attrs:{"src":require("@/assets/img/logo.svg"),"alt":"Logo Venda e Ganhe"}}),_c('div',{staticClass:"progress-container"},[_c('b-progress',{attrs:{"type":"is-primary","size":"is-small"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }